<script lang="ts">
  export let text = 'Loading...';
</script>

<div class="loader-container">
  <span class="loader"></span>
  {#if text}
    <span>{text}</span>
  {/if}
</div>

<style>
  .loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .loader {
    width: 24px;
    height: 24px;
    border: 4px solid;
    border-color: #00aa00 transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
